import Paper from '@mui/material/Paper'
import InputBase from '@mui/material/InputBase'
import IconButton from '@mui/material/IconButton'
import SearchIcon from '@mui/icons-material/Search'
import { Grid } from '@mui/material'

import './SearchBox.css'

const SearchBox = ({ searchText,setSearchText,placeholder = 'جستجو کنید ...' }) => {
  return (
    <div id="search-box">
        <Grid item px={0.2}>
            <Paper component="form" sx={{ p: '2px 10px', display: 'flex', alignItems: 'center', width: '100%', boxSizing: 'border-box' }}>
                <InputBase sx={{ ml: 1, flex: 1, fontSize: 14, }} placeholder={placeholder} value={searchText} onChange={e => setSearchText(e.target.value)} />
                <SearchIcon sx={{ color: '#cccccc',p: '10px 0' }} />
            </Paper>
        </Grid>
    </div>
  )
}

export default SearchBox